import { getEnv } from "@/env";

const URL_RESOLUTION_BASE = getEnv(
  "NEXT_PUBLIC_SITE_URL",
  "https://www.edx.org",
);

type AppendAlgoliaQueryParamsToHrefArgs = {
  href?: string;
  index: string;
  queryId: string;
  position: string;
};

const isHttpOrHttpsUrl = (href: string) => /^https?:\/\//i.test(href);

const isProtocolRelativeUrl = (href: string) => href.startsWith("//");

const isNonHttpProtocol = (href: string) =>
  /^[a-z][a-z0-9+.-]*:/i.test(href) && !isHttpOrHttpsUrl(href);

const formatUrlWithQueryParams = (url: URL, hrefValue: string): string => {
  if (isHttpOrHttpsUrl(hrefValue)) {
    return url.toString();
  }

  if (isProtocolRelativeUrl(hrefValue)) {
    return `//${url.host}${url.pathname}${url.search}${url.hash}`;
  }

  return `${url.pathname}${url.search}${url.hash}`;
};

/**
 * Appends Algolia/Segment tracking query params to a product href.
 * Uses a stable base URL so this is safe during SSR (no window access).
 */
export function appendAlgoliaQueryParamsToHref({
  href,
  index,
  queryId,
  position,
}: AppendAlgoliaQueryParamsToHrefArgs): string {
  const hrefValue = href || "/";

  if (isNonHttpProtocol(hrefValue)) {
    return hrefValue;
  }

  const url = isHttpOrHttpsUrl(hrefValue)
    ? new URL(hrefValue)
    : new URL(hrefValue, URL_RESOLUTION_BASE);

  url.searchParams.set("index", index);
  url.searchParams.set("queryId", queryId);
  url.searchParams.set("position", position);

  return formatUrlWithQueryParams(url, hrefValue);
}
